import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISiteOIDCConfigurationViewModel } from './GetOrCreateSiteOIDCConfigurationViewModelRequest';

export interface ISiteAllOIDCConfigurationViewModel extends IResult {
  results: ISiteOIDCConfigurationViewModel[];
  }

export class GetAllOIDCConfigurationsRequest extends Request<{}, ISiteAllOIDCConfigurationViewModel> {
  constructor() {
    super('getAllOIDCConfigurations', {});
  }
}



